import { CommunicationWindowManager, PaymentParams } from "@toruslabs/base-controllers";
import { JRPCEngine } from "@toruslabs/openlogin-jrpc";

import simplex from "./simplex";
import topper from "./topper";
import { TOPUP } from "./topup-enums";

interface TopUp {
  getOrder: (
    params: PaymentParams,
    engine?: {
      communicationEngine: JRPCEngine | undefined;
      communicationWindowManager: CommunicationWindowManager;
    }
  ) => Promise<URL>;
}

export default {
  [TOPUP.SIMPLEX]: simplex,
  [TOPUP.TOPPER]: topper,
} as { [k: string]: TopUp };
